// extracted by mini-css-extract-plugin
module.exports = {"next-sr-only":"ExportBlack--next-sr-only--3n3LTOG","export-black-list":"ExportBlack--export-black-list--1eVhbar","display-flex":"ExportBlack--display-flex--3A9YcuG"};